module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3d banner valign-wrapper",
    class: {
      'govcloud': _vm.user.isGovcloudUser
    },
    staticStyle: {
      "padding": "0 5em",
      "justify-content": "space-between",
      "position": "relative"
    }
  }, [(!_vm.user.loaded) ? [_vm._m(0)] : [_c('div', {
    staticClass: "subscription-block"
  }, [(_vm.subscription) ? _c('div', {
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_vm._v("\n        You have unlimited credits until "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.subscription))])]) : _vm._e(), _vm._v(" "), (!_vm.subscription && _vm.user.credits.length === 0) ? _c('div', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("\n        To submit a job, you need to buy a subscription.\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.subscription && _vm.user.credits.length > 0) ? _c('div', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("\n        You can submit one job per credit.\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.user.isGovcloudUser && _vm.subscription) ? _c('div', {
    staticClass: "govcloud-secure"
  }, [_vm._v("\n      Secure GovCloud\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticClass: "valign-wrapper",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "bottom": "0",
      "left": "0",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-direction": "column",
      "margin": "auto",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "3.5em",
      "line-height": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.user.credits.length) + " ")]), _vm._v(" "), _c('div', [_vm._v("credits")])])]) : _vm._e(), _vm._v(" "), (!_vm.subscription) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "z-index": "1",
      "font-size": "0.8em",
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_c('buy-credits', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showModal = $event
      },
      "update:show-modal": function($event) {
        _vm.showModal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(props) {
        return _c('a', {
          staticClass: "a3d btn inv dark",
          on: {
            "click": props.open
          }
        }, [_vm._v("\n          + Buy Subscription\n        ")])
      }
    }], null, false, 3326603751)
  }), _vm._v(" "), (_vm.user.isGovcloudUser) ? _c('div', {
    staticClass: "govcloud-secure"
  }, [_vm._v("\n        Secure GovCloud\n      ")]) : _vm._e()], 1) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader-wrapper small active"
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38ba4ea0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ba4ea0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 478
// module chunks = 1